module.exports = __webpack_public_path__ + "img/puntos.195d3a75.svg";